import {toSuffixed} from "./toSuffixed";

export const formatBedrooms = (bedrooms: number) => {
  return bedrooms >= 0 ? toSuffixed(bedrooms, "bed", "beds", "Studio") : "Room";
};
